<template>  
    <div>
        <v-layout row wrap justify-center align-center text-xs-center pb-5 class="cont_page">
            <v-flex mt-5 md12>
                <button class="btn-primary" @click='abrirModal(0)'> 
                <strong>1</strong>
                </button>
                <button class="btn-secondary" @click='abrirModal(1)'>
                <strong>2</strong>
                </button>
                <button class="btn-primary" @click='abrirModal(2)'>
                <strong>3</strong>
                </button>
                <button class="btn-secondary" @click='abrirModal(3)'>
                <strong>4</strong>
                </button>
                <button class="btn-primary" @click='abrirModal(4)'>
                <strong>5</strong>
                </button>
        </v-flex> 
        </v-layout>
        <modal-app v-model="modal" :fullscreen="false" :width="width" :mostrarCerrar="mostrarCerrar" :border="border" :image="image">
            <template slot="modaltittle">
                <h1>{{titulo}}</h1>
                <v-spacer></v-spacer>
            </template>
            <template slot="modalcontent">
                <v-layout wrap row justify-center align-center  mb-5>
                <v-flex v-if="image !=''">
                    <img :src="require('../../assets/unidad2/'+image)" alt="">
                    <v-btn v-if="btn != ''" @click="modal = false">{{btn}} </v-btn>               
                </v-flex>
                </v-layout>
                <v-flex>
                    <p v-html="contenido"></p>
                </v-flex>
            </template>
        </modal-app>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import resourcesLoader from "../../js/mixins/resources-loader";
import modal from "../../components/modal2"
export default {
mixins: [nextConditions,resourcesLoader],
components:{
    "modal-app":modal
},
data() {
    return {
    modal:false,
    dato: {},
    titulo:'',
    body:'',
    width:'200px',
    btn: '',
    image:'img1.png',
    mostrarCerrar: true,
    border:'',
    contenido:''
    }
},
  // funcion flecha va iterando y va añadiendo los elementos de el this
created() {
            this.getJson('mod9', data => {
                this.dato = data
            })
        },
methods:{
    abrirModal(val){
        this.modal=true;
        this.titulo = this.dato.infomodal[val].title
        this.contenido = this.dato.infomodal[val].body
        this.width = this.dato.infomodal[val].width
        if (this.dato.infomodal[val].image) {
            this.image = this.dato.infomodal[val].image
        } else {
            this.image = ''
        }
        this.border = this.dato.infomodal[val].border
        if (!this.dato.infomodal[val].mostrarCerrar) {
            this.mostrarCerrar = this.dato.infomodal[val].mostrarCerrar
        }else{
            this.mostrarCerrar = true
        }

        if (this.dato.infomodal[val].boton) {
            this.btn = this.dato.infomodal[val].boton
        }else{
            this.btn = ''
        }
    }
}
}
</script>

<style scoped>
.btn-primary, .btn-secondary{
    padding: 10px 10px;
    margin: 10px;
    width: 70px;
    font-size: 50px;
}
</style>